export default "__VITE_ASSET__BXGh6iWQ__"